import {Component, Element, h, Host, Prop} from '@stencil/core';
import {hasTouchSupport} from '@baloise/ds-core';
import {replaceImageSrcPlaceholder} from '../../utils/utils';

@Component({
  tag: 'bam-image',
  styleUrl: 'bam-image.scss',
})
export class BamImage {
  @Element() host: HTMLElement;
  @Prop() image?: string;
  @Prop() altImage: string = '';
  @Prop() titleImage?: string;
  @Prop() srcSet?: string;
  @Prop() figureExtraClass?: string;
  @Prop() hasRoundedBorder?: '4' | '8' | '12' | 'full' | 'none' = 'none';
  @Prop() isAnimated = false;
  @Prop() isNotLazy = false;
  private sourcesList: string[] = [];
  private aspectRatioList: RegExpMatchArray[];
  private lazyLoading: boolean;

  connectedCallback() {
    if (this.srcSet?.length >= 1) {
      const regex = new RegExp(/\/(\d+)-(\d+)\//, 'g');
      this.sourcesList = this.srcSet.replace(/[\[\]\"\n\s]/g, '').split(',');
      this.aspectRatioList = [...this.sourcesList.toString().matchAll(regex)];
    }
  }

  componentWillLoad() {
    this.lazyLoading = this.isNotLazy ? false : !this.elementInViewport();
  }

  elementInViewport() {
    const rect: DOMRect = this.host.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  renderImg(sourcesList, altImage, titleImage, aspectRatioList) {
    return (
      <img
        loading={this.lazyLoading ? 'lazy' : 'eager'}
        // @ts-ignore
        fetchpriority={this.lazyLoading ? 'low' : 'high'}
        class="bam-image__source"
        src={`${replaceImageSrcPlaceholder(sourcesList[0])}`}
        srcSet={`${replaceImageSrcPlaceholder(sourcesList[0])} 1x, ${replaceImageSrcPlaceholder(sourcesList[1])} 2x`}
        alt={altImage}
        title={!!titleImage ? titleImage : ''}
        width={aspectRatioList.length ? aspectRatioList[0][1] : undefined}
        height={aspectRatioList.length ? aspectRatioList[0][2] : undefined}
        decoding={this.lazyLoading ? 'async' : 'sync'}
      />
    );
  }

  render() {
    const { image, altImage, titleImage, sourcesList, aspectRatioList, figureExtraClass, hasRoundedBorder } = this;
    const isAnimated = this.isAnimated && !hasTouchSupport();

    return (
      <Host>
        <figure app-hasRoundedBorder={hasRoundedBorder} app-animated={isAnimated} class={`bam-image__figure ${figureExtraClass ? figureExtraClass : ''}`}>
          <div class="bam-image__imageContainer">
            {sourcesList.length > 2 && (
              <picture>
                {sourcesList[8] && sourcesList[9] && (
                  <source
                    media="(min-width: 1408px)"
                    srcSet={`${sourcesList[8]} 1x, ${sourcesList[9]} 2x`}
                    // @ts-ignore
                    width={aspectRatioList.length ? Number(aspectRatioList[8][1]) : undefined}
                    // @ts-ignore
                    height={aspectRatioList.length ? Number(aspectRatioList[8][2]) : undefined}
                  />
                )}
                {sourcesList[6] && sourcesList[7] && (
                  <source
                    media="(min-width: 1216px)"
                    srcSet={`${sourcesList[6]} 1x, ${sourcesList[7]} 2x`}
                    // @ts-ignore
                    width={aspectRatioList.length ? Number(aspectRatioList[6][1]) : undefined}
                    // @ts-ignore
                    height={aspectRatioList.length ? Number(aspectRatioList[6][2]) : undefined}
                  />
                )}
                {sourcesList[4] && sourcesList[5] && (
                  <source
                    media="(min-width: 1024px)"
                    srcSet={`${sourcesList[4]} 1x, ${sourcesList[5]} 2x`}
                    // @ts-ignore
                    width={aspectRatioList.length ? Number(aspectRatioList[4][1]) : undefined}
                    // @ts-ignore
                    height={aspectRatioList.length ? Number(aspectRatioList[4][2]) : undefined}
                  />
                )}
                {sourcesList[2] && sourcesList[3] && (
                  <source
                    media="(min-width: 769px)"
                    srcSet={`${sourcesList[2]} 1x, ${sourcesList[3]} 2x`}
                    // @ts-ignore
                    width={aspectRatioList.length ? Number(aspectRatioList[2][1]) : undefined}
                    // @ts-ignore
                    height={aspectRatioList.length ? Number(aspectRatioList[2][2]) : undefined}
                  />
                )}
                {this.renderImg(sourcesList, altImage, titleImage, aspectRatioList)}
              </picture>
            )}
            {sourcesList.length === 2 && this.renderImg(sourcesList, altImage, titleImage, aspectRatioList)}
            {image && (
              <img
                loading={this.lazyLoading ? 'lazy' : 'eager'}
                // @ts-ignore
                fetchpriority={this.lazyLoading ? 'low' : 'high'}
                class="bam-image__source"
                src={image}
                alt={altImage}
                title={!!titleImage ? titleImage : ''}
                decoding={this.lazyLoading ? 'async' : 'sync'}
              />
            )}
          </div>
        </figure>
      </Host>
    );
  }

}
